import { Theme, useMediaQuery } from '@mui/material';
import { RichTreeView, TreeViewBaseItem, useTreeViewApiRef } from '@mui/x-tree-view';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLayoutContext } from '../../useLayoutContext';
import ReportTreeItem from "./ReportTreeItem";
import { SectionType } from "../../../../types";
import { ExtendedTreeViewBaseItem, selectReportDrawerSections } from '../../../../redux/slices/reportSlice/report';
import { useAppSelector } from "../../../../redux/store";
import LoadingSkeleton from "../LoadingSkeleton";

const MenuTreeView = () => {
  const { drawerSections, setDrawerSections, setDrawerOpen } = useLayoutContext();
  const reportSections = useAppSelector(selectReportDrawerSections);

  useEffect(() => {
    setDrawerSections([
      {
        id: 'summary',
        label: 'Summary',
        children: undefined,
        path: '#summary',
      },
      ...reportSections
    ]);
  }, [reportSections, setDrawerSections]);

  const apiRef = useTreeViewApiRef();

  const location = useLocation();
  const navigate = useNavigate();
  const matchDownSM = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const isItemDisabled = (item: ExtendedTreeViewBaseItem) => Boolean(item?.disabled);

  const handleClick = (_: React.MouseEvent, itemId: string) => {
    const { path } = apiRef?.current?.getItem(itemId) as TreeViewBaseItem<SectionType>;
    if (path === location.pathname) return;

    if (path.startsWith('#')) {
      navigate(location.pathname + location.search + path);
    } else {
      navigate(path);
    }
    if (matchDownSM) {
      setDrawerOpen(false);
    }
  };

  if (reportSections.length === 0) return <LoadingSkeleton />;

  return (
    <RichTreeView
      apiRef={apiRef}
      items={drawerSections}
      onItemClick={handleClick}
      isItemDisabled={isItemDisabled}
      slots={{
        item: ReportTreeItem,
      }}
    />
  );
};

export default React.memo(MenuTreeView);
